module.exports = __webpack_public_path__ + "static/media/truck.75107d49.svg";